import { MINUTES_ACTION_TYPES } from "./types";

// Initial State
const initialState = {
  minutes: [],
  minute: {},
  selectedMinute: null,
  filter: null, // business id
  loading: false,
  error: null,
  lastFetch: null,

  // Request states for different operations
  creating: false,
  updating: false,
  deleting: false,
};

// Reducer
export const MinutesReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Cases
    case MINUTES_ACTION_TYPES.FETCH_MINUTES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case MINUTES_ACTION_TYPES.FETCH_MINUTES_SUCCESS:
      return {
        ...state,
        loading: false,
        minutes: action.payload,
        error: null,
      };

    case MINUTES_ACTION_TYPES.FETCH_MINUTES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    //fetch minute by id
    case MINUTES_ACTION_TYPES.FETCH_MINUTE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case MINUTES_ACTION_TYPES.FETCH_MINUTE_SUCCESS:
      return {
        ...state,
        loading: false,
        minute: action.payload,
        error: null,
      };
    case MINUTES_ACTION_TYPES.FETCH_MINUTE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // Create Cases
    case MINUTES_ACTION_TYPES.CREATE_MINUTE_REQUEST:
      return {
        ...state,
        creating: true,
        error: null,
      };

    case MINUTES_ACTION_TYPES.CREATE_MINUTE_SUCCESS:
      return {
        ...state,
        creating: false,
        minute: [...state.minutes, action.payload],
        error: null,
      };

    case MINUTES_ACTION_TYPES.CREATE_MINUTE_FAILURE:
      return {
        ...state,
        creating: false,
        error: action.payload,
      };

    // Update Cases
    case MINUTES_ACTION_TYPES.UPDATE_MINUTE_REQUEST:
      return {
        ...state,
        updating: true,
        error: null,
      };

    case MINUTES_ACTION_TYPES.UPDATE_MINUTE_SUCCESS:
      return {
        ...state,
        updating: false,
        minutes: state.minutes.map((minute) =>
          minute.id === action.payload.id ? action.payload : minute
        ),
        selectedMinute:
          state.selectedMinute?.id === action.payload.id
            ? action.payload
            : state.selectedMinute,
        error: null,
      };

    case MINUTES_ACTION_TYPES.UPDATE_MINUTE_FAILURE:
      return {
        ...state,
        updating: false,
        error: action.payload,
      };

    // Delete Cases
    case MINUTES_ACTION_TYPES.DELETE_MINUTE_REQUEST:
      return {
        ...state,
        deleting: true,
        error: null,
      };

    case MINUTES_ACTION_TYPES.DELETE_MINUTE_SUCCESS:
      return {
        ...state,
        deleting: false,
        minutes: state.minutes.filter((minute) => minute.id !== action.payload),
        selectedMinute:
          state.selectedMinute?.id === action.payload
            ? null
            : state.selectedMinute,
        error: null,
      };

    case MINUTES_ACTION_TYPES.DELETE_MINUTE_FAILURE:
      return {
        ...state,
        deleting: false,
        error: action.payload,
      };

    // UI Cases
    case MINUTES_ACTION_TYPES.SET_SELECTED_MINUTE:
      return {
        ...state,
        selectedMinute: action.payload,
      };

    case MINUTES_ACTION_TYPES.CLEAR_SELECTED_MINUTE:
      return {
        ...state,
        selectedMinute: null,
      };

    case MINUTES_ACTION_TYPES.SET_FILTER:
      return {
        ...state,
        filter: action.payload,
      };

    case MINUTES_ACTION_TYPES.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
